import "../../css/home.css";

const CommitmentSection = () => {
  return (
    <section className="commitment-section">
      <div className="container w-75">
        <div className="commitment-title">
          ZTO CAM KẾT
        </div>
        <div className="commitment-description pb-4 text-center">
          <span>Chất lượng tạo nên thương hiệu -
          Uy tín giữ vững niềm tin</span>
        </div>
        <div className="row justify-content-between">
          <div className="col-md-6 commitment-box">
            <div className="item-title">Nhanh chóng & Đúng hẹn</div>
            <p>
              Mọi đơn hàng đều được xử lý tự động và giao đúng
              thời gian cam kết. Tuyến Trung – Việt chỉ 2 ngày,
              tuyến Bắc – Nam trong 24h.
            </p>
          </div>
          <div className="col-md-6 commitment-box">
            <div className="item-title">Giá cước minh bạch - tối ưu chi phí</div>
            <p>
              Bảng giá công khai, rõ ràng. Không phụ phí ẩn. Tối ưu chi phí cho khách hàng cá nhân lẫn doanh nghiệp.
            </p>
          </div>
        </div>
        <div className="row commitment-items mt-4">
          <div className="col-md-6 commitment-box">
            <div className="item-title">Hệ thống theo dõi hiện đại</div>
            <p>
              Theo dõi hành trình đơn hàng 24/7 qua website
              hoặc app. Cập nhật tức thời, minh bạch.
            </p>
          </div>
          <div className="col-md-6 commitment-box">
            <div className="item-title">Bảo mật tuyệt đối</div>
            <p>
              Cam kết bảo vệ thông tin khách hàng và nội dung
              hàng hóa theo tiêu chuẩn quốc tế.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommitmentSection;